import React, { useState, useEffect } from "react";
import { Select, Input, Button } from "antd";
import { uri } from "../backendUri";
import axiosApi from "../axiosApi/axiosApi";

const { Option } = Select;
const { Search } = Input;

const columnFieldMap = [
  { label: 'Product SKU', value: 'sku' },
  { label: 'Product Name', value: 'name' },
  { label: 'Brand', value: 'brands' },
  { label: 'Regular Price', value: 'regular_price' },
  { label: 'Sale Price', value: 'sale_price' },
  { label: 'Stock Status', value: 'stock_status' },
  { label: 'Stock Quantity', value: 'stock_quantity' },
  { label: 'Condition', value: 'gr_stock_status' },
];
export default function CategoryBaseProducts({ isCatogoryDevice,
  setIsCatogoryDevice,
  handleSearchFromSearchBar,
  setSlectedCaogory,
  setGlobalSearchVal,
  setIsCsvModal,
  setRowCatogories,
  setIsCsvExportModal,
  setSearchTerm,
  fetchProducts
}) {

  const [categories, setCategories] = useState([]);
  const [parentCategories, setParentCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]); // Subcategories of selected parent
  const [filteredSubSubCategories, setFilteredSubSubCategories] = useState([]); // Subcategories of selected subcategory
  const [selectedParent, setSelectedParent] = useState(null);
  const [selectedSub, setSelectedSub] = useState(null);
  const [selectedSubSub, setSelectedSubSub] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchField, setSearchField] = useState('name');

  const fetchCategories = async () => {
    setLoading(true)
    try {
      const { data } = await axiosApi.get(`/fetchWommerce-products-catogories`)
      setCategories(data);
      setRowCatogories(data)
      const parents = data.filter((cat) => cat.parent === 0);
      const subs = data.filter((cat) => cat.parent !== 0);
      setParentCategories(parents);
      setSubCategories(subs);

    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleParentChange = (parentId, catogory) => {

    if (parentId === 176 && !isCatogoryDevice) {
      setIsCatogoryDevice(true)
    } else {
      setIsCatogoryDevice(false)
    }
    setSlectedCaogory(Number(catogory.key))
    setSelectedParent(parentId);
    setSelectedSub(null);
    setSelectedSubSub(null);

    const filteredSubs = subCategories.filter((sub) => sub.parent === parentId);
    setFilteredSubCategories(filteredSubs);
    setFilteredSubSubCategories([]); // Clear sub-subcategories
  };

  const handleSubChange = (subId) => {
    setSelectedSub(subId);
    setSelectedSubSub(null); // Reset sub-subcategory
    setSlectedCaogory(Number(subId))
    const filteredSubSubs = subCategories.filter((sub) => sub.parent === subId);
    setFilteredSubSubCategories(filteredSubSubs);
  };
  const handleSubOfSubChange = (subId) => {
    setSelectedSubSub(subId);
    setSlectedCaogory(subId)
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value)
    setSearchTerm(pre => {
      pre[searchField] = e.target.value
      return pre;
    })
  };

  return (
    <div style={{ padding: 20, display: "flex", alignItems: "center", gap: 10 }}>

      <Select
        showSearch
        loading={loading}
        style={{ width: 200 }}
        placeholder="Select Parent Category"
        onChange={handleParentChange}
        defaultValue={'All'}
        allowClear
      >
        {parentCategories.map((category) => (
          <Option key={category.id} value={category.id}>
            {category.name}
          </Option>

        ))}
        {
          !loading &&
          <Option key={-1} value={-1}>
            {'All'}
          </Option>
        }
      </Select>

      {selectedParent && filteredSubCategories.length > 0 && (
        <Select
          style={{ width: 200 }}
          placeholder="Select Subcategory"
          onChange={handleSubChange}
          allowClear
        >
          {filteredSubCategories.map((sub) => (
            <Option key={sub.id} value={sub.id}>
              {sub.name}
            </Option>

          ))}

        </Select>
      )}

      {selectedSub && filteredSubSubCategories.length > 0 && (
        <Select
          style={{ width: 200 }}
          placeholder="Select Sub-Subcategory"
          onChange={handleSubOfSubChange}
          allowClear
        >
          {filteredSubSubCategories.map((subSub) => (
            <Option key={subSub.id} value={subSub.id}>
              {subSub.name}
            </Option>
          ))}
        </Select>
      )}


      <Input.Search
        style={{ width: '50%', minWidth: '200px', textAlign: 'left' }}
        value={searchQuery}
        placeholder={`Search by ${searchField}`}
        onPressEnter={(e) => fetchProducts(0, { [searchField]: searchQuery })}

        enterButton={

          <Button onClick={() => fetchProducts(0, { [searchField]: searchQuery })} type="primary" style={{ background: "#1677ff", color: "white" }}>
            {`Search by ${searchField}`}
          </Button>
        }
        onSearch={() => searchQuery && handleSearch()}
        onChange={(e) => handleSearch(e)}
      />
      <Select
        defaultValue="name"
        type="primary"
        style={{ width: 200 }}
        onChange={(value) => {
          setSearchTerm({ [value]: searchQuery || '' })
          setSearchField(value)
        }}
      >
        {columnFieldMap.map((col) => (
          <Option key={col.value} value={col.value}>
            {col.label}
          </Option>
        ))}
      </Select>
      <div style={{ display: 'flex', width: '50%', justifyContent: 'flex-end', marginRight: 10, gap: 10 }}>

        <Button loading={loading} disabled={loading} onClick={() => setIsCsvExportModal(true)} type="primary" style={{ background: "#1677ff", color: "white" }}>
          {loading ? "Catagories Loading..." : "Export Data"}
        </Button>
        <Button loading={loading} disabled={loading} onClick={() => setIsCsvModal(true)} type="primary" style={{ background: "#1677ff", color: "white" }}>
          {loading ? "Catagories Loading..." : "Import Data"}
        </Button>
      </div>
    </div>
  );
}
